import type { InternalAgentProvenance, InternalAgentVisibility } from '@localagent/sdk';

export function InternalAgentIdentity({
  provenance,
  visibility,
}: {
  provenance: InternalAgentProvenance;
  visibility: InternalAgentVisibility;
}) {
  return (
    <div data-testid="internal-agent-identity" className="text-micro text-muted-foreground">
      <span className="font-medium text-foreground">{provenance.friendlyLabel}</span>
      {visibility === 'exact' && (
        <span data-testid="internal-agent-exact-provenance">
          {' · '}{provenance.personaName}
          {provenance.processName && ` · ${provenance.processName}`}
          {provenance.processId && ` (${provenance.processId})`}
        </span>
      )}
    </div>
  );
}
